import type * as Types from '../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StudentHomepageStudentQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type StudentHomepageStudentQuery = { __typename?: 'RootQueryType', user?: { __typename?: 'User', id: string, email: string } | null };


export const StudentHomepageStudentDocument = gql`
    query StudentHomepageStudent($id: ID!) {
  user(id: $id) {
    id
    email
  }
}
    `;

/**
 * __useStudentHomepageStudentQuery__
 *
 * To run a query within a React component, call `useStudentHomepageStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentHomepageStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentHomepageStudentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentHomepageStudentQuery(baseOptions: Apollo.QueryHookOptions<StudentHomepageStudentQuery, StudentHomepageStudentQueryVariables> & ({ variables: StudentHomepageStudentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentHomepageStudentQuery, StudentHomepageStudentQueryVariables>(StudentHomepageStudentDocument, options);
      }
export function useStudentHomepageStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentHomepageStudentQuery, StudentHomepageStudentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentHomepageStudentQuery, StudentHomepageStudentQueryVariables>(StudentHomepageStudentDocument, options);
        }
// @ts-ignore
export function useStudentHomepageStudentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StudentHomepageStudentQuery, StudentHomepageStudentQueryVariables>): Apollo.UseSuspenseQueryResult<StudentHomepageStudentQuery, StudentHomepageStudentQueryVariables>;
export function useStudentHomepageStudentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StudentHomepageStudentQuery, StudentHomepageStudentQueryVariables>): Apollo.UseSuspenseQueryResult<StudentHomepageStudentQuery | undefined, StudentHomepageStudentQueryVariables>;
export function useStudentHomepageStudentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StudentHomepageStudentQuery, StudentHomepageStudentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StudentHomepageStudentQuery, StudentHomepageStudentQueryVariables>(StudentHomepageStudentDocument, options);
        }
export type StudentHomepageStudentQueryHookResult = ReturnType<typeof useStudentHomepageStudentQuery>;
export type StudentHomepageStudentLazyQueryHookResult = ReturnType<typeof useStudentHomepageStudentLazyQuery>;
export type StudentHomepageStudentSuspenseQueryHookResult = ReturnType<typeof useStudentHomepageStudentSuspenseQuery>;
export type StudentHomepageStudentQueryResult = Apollo.QueryResult<StudentHomepageStudentQuery, StudentHomepageStudentQueryVariables>;